export const SRC_IMAGE = process.env.SRC_IMAGE;